import { readingView, type ReadingState, type ReadingViewOptions } from './reading';

export interface ReadingNoteProps extends ReadingViewOptions {
  reading: ReadingState | null | undefined;
  /**
   * A frase da tela em volta do `{reading}` («Túnel e raiz: {reading}», «cluster {reading}»). Sem ela, o elemento
   * mostra só o `{reading}`.
   */
  compose?: (reading: string) => string;
  className?: string;
  /** O `data-testid` do elemento. Padrão: `reading`. */
  testId?: string;
}

/**
 * A hora da foto e o estado da leitura nova, num elemento só (aim-6ph.13). O `data-state` leva a letra do protótipo
 * (A, B, C ou D), e o `data-unconfirmed` marca a leitura que passou do teto: é por eles que os testes afirmam, e não
 * pela frase, que é copy e muda com o idioma.
 *
 * Sem bloco na resposta, ou sem nada a dizer (D sem leitura em curso e sem falha), não desenha nada.
 */
export function ReadingNote({ reading, compose, className, testId = 'reading', ...options }: ReadingNoteProps) {
  const view = readingView(reading, options);
  if (!view || !view.text) return null;
  return (
    <span
      className={className}
      data-testid={testId}
      data-state={view.state}
      data-unconfirmed={view.unconfirmed ? 'true' : undefined}
    >
      {compose ? compose(view.text) : view.text}
    </span>
  );
}
